module.exports = __webpack_public_path__ + "static/media/best-anywhere.7e099e27.svg";